module.exports = __webpack_public_path__ + "static/img/009_TO8_1467_og.579f304.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/009_TO8_1467_og.jpg
// module id = WKGM
// module chunks = 0